import Seeds from "./Seeds";
export default Seeds;